<template>
  <AppWrapper>
    <div class="app__layout">
      <div class="app__layout--header">
        <h4>Terms</h4>
      </div>

      <div class="app__layout--tabs">
        <input type="radio" id="tab1" name="tab-control" checked>
        <input type="radio" id="tab2" name="tab-control">
        <!-- <input type="radio" id="tab3" name="tab-control"> -->

        <div class="app__layout--tabs__contents">
          <TermsComponent />
          <!-- <LoanTerms /> -->
          <PrivacyView />
        </div>
      </div>
    </div>
  </AppWrapper>
</template>

<script setup>
import { onMounted } from 'vue';
import AppWrapper from '@/components/AppWrapper.vue';
// import TermsView from './components/TermsView.vue';
import PrivacyView from './components/PrivacyView.vue';
import { useRoute } from "vue-router";
import { event } from 'vue-gtag'
import TermsComponent from './components/TermsComponent.vue';
// import LoanTerms from './components/LoanTerms.vue';

const route = useRoute();
onMounted(() => {
  clickActiveTab();
})

const clickActiveTab = () => {
  const type = "TERMS OF USE";
  event(
    'ToggleTermsAndPrivacy',
    {
      method: 'User read the terms of use and privacy policy.',
      view: type,
    }
  );
  document.getElementById(`${route.params.tab}`).click();
}
</script>
